export { NoDataView, NoDataViewVariant } from './NoDataView';
